import moment from "moment";
import React, { useEffect, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row } from "reactstrap";
import { decryptData} from "../../utils/helper";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../utils/Tostify";
import { downloadAgreement, getAllParticipantStatus, resetAgreement, sendAgreementViaSMS, updateApplication } from "../../api/Applications";
import { getAllSigner } from "../../api/workflow";
import { useNavigate } from "react-router";
import { platformLayout } from "../../utils/constants";
import AdobeSignatureModel from "./AdobeSignatureModel";
import Loader from "../../components/Loader/Loader";
import PhoneInput from "react-phone-input-2";
import { formStatus, stageStatusOption } from "./Constant";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';


const Signature = ({application, getApplication, activeTab,setActiveTab}) => {

  const navigate = useNavigate();
  const dispatch  = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const { getConfirmation } = useConfirmDialog();
  const [isLoading, setIsLoading] = useState(false);
  let token = useSelector(state => state.userReducer.token);
  let role = localStorage.getItem("userRole");
  const [signerModelShow, setShowSignerModel] = useState(false);
  const [signerList, setsignerList] = useState([]);
  const [signerData, setSignerData] = useState({});
  const [agreementsData, setAgreementsData] = useState([]);
  const [formEditingIndex, setFormEditingIndex] = useState(null);
  const [formTitle, setFormTitle] = useState('');
  const [phoneNumbers, setPhoneNumbers] = useState({}); // This can store phone numbers with participant's email as key
  const [tempPhoneNumbers, setTempPhoneNumbers] = useState({});
  const [activeTableTab, setActiveTableTab] = useState(role === "Patient" ? "patientActiveSignature" : "signatures");
  const [formList, setFormList] = useState([]);
  const [signModal, setSignModal] = useState(false);
  const [signUrl, setSignUrl] = useState(null);
  let user = useSelector((state) => state?.userReducer?.user);
  let PatientEmail = null;
  if (role === "Patient") {
    const emailValue = user?.telecom?.find(t => t.system === "email")?.value;
    PatientEmail = decryptData(emailValue);
  }
  const [completedPatientForms, setCompletedPatientForms] = useState([]);

  const toggleDropdown = (id) => {
    setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
  };

 const handleRemoveSigner = async(agreementId, formId) =>{
  const confirmed = await getConfirmation({
    title: "Attention!",
    entryName: "",
    actionBtnTitle: "Yes",
    message: `Are you sure you want to Reset Signer?`
  });
  if (confirmed) {
      let res;
      try {
          const values = {applicationId: application?._id , formId, agreementId};
          setIsLoading(true);
          res = await resetAgreement({values, dispatch, token});
          if (res?.status === "SUCCESS") {
              setIsLoading(false);
              const updatedApplicationForm = application.applicationForms.map((form) =>
                form.formId === formId
                  ? { ...form, status: "InProgress",agreementId:"", participants:[]}
                  : form
              );
              const values = { applicationForms: updatedApplicationForm };
              setIsLoading(true);
              setActiveTab("2");
              // Perform the update operation to mark the form as "Completed"
              const res = await updateApplication({
                values,
                dispatch,
                token,
                applicationId: application?._id
              });

              await getApplication();
              success(res?.message);
          } else {
              setIsLoading(false);
              failed(res?.message);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      }
    }
  };

  const getSigners = async (page, limit, searchKey = "") => {
    let res;
    try {
        setIsLoading(true);
        res = await getAllSigner({dispatch, token, page, limit, searchKey, dataLimit: "all"});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            setsignerList(responseData.items);
            setIsLoading(false);
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAndProcessData();
    if (application?.applicationForms?.length > 0 && activeTab === "6") {
      getAgreementList();
    }
    setFormEditingIndex(null);
    // setActiveTableTab("signatures");
  }, [activeTab,application]);

  const getAgreementList = async () => {
    let res;
    try {
      const agreementIds =
        application?.applicationForms
          ?.filter((form) => form?.agreementId) // Filter forms with valid agreementId
          .map((form) => form?.agreementId) || [];

      // Check if agreementIds has any data
      if (agreementIds.length === 0) {
        return; // Exit function if no agreementIds
      }

      setIsLoading(true);
      res = await getAllParticipantStatus({ values: { agreementIds }, dispatch, token });
      const responseData = decryptData(res?.data);

      if (res?.status === "SUCCESS") {
        setAgreementsData(responseData);
      } else {
        failed(res?.message);
      }
    } catch (error) {
      failed(res?.message);
    } finally {
      setIsLoading(false); // Ensure loading state is reset in both success and error cases
    }
  };

  const filterAndLogCompletedAgreements = async (agreement, matchedForm) => {
    try {
      // Update the form status to "Completed"
      const updatedApplicationForm = application.applicationForms.map((form) =>
        form.formId === matchedForm?.formId
          ? { ...form, status: "Completed"}
          : form
      );
      const values = { applicationForms: updatedApplicationForm };
      setIsLoading(true);
      // Perform the update operation to mark the form as "Completed"
      const res = await updateApplication({
        values,
        dispatch,
        token,
        applicationId: application?._id
      });

      if (res?.status === "SUCCESS") {
        // Check if the form does not have an agreement URL and needs to be updated
        if (matchedForm) {
          const downloadRes = await downloadAgreement({
            values: { agreementId: matchedForm?.agreementId,applicationId: application?._id,formTitle :  matchedForm.formTitle + "_signed" },
            dispatch,
            token
          });
          if (downloadRes?.data.key) {
            const updatedApplicationFormWithUrl = application.applicationForms.map(
              (form) =>
                form._id === matchedForm?._id
                  ? { ...form,status: "Completed", agreementUrl: downloadRes?.data?.key, formFile:{ key: downloadRes?.data?.key}, formTitle :  form.formTitle + "_signed" }
                  : form
            );

            const valuesWithUrl = { applicationForms: updatedApplicationFormWithUrl };
            // Perform the update operation for the agreement URL
            const updateRes = await updateApplication({
              values: valuesWithUrl,
              dispatch,
              token,
              applicationId: application?._id
            });
            await getApplication();
            if (updateRes?.status !== "SUCCESS") {
              failed(updateRes?.message || "Error updating agreement URL");
            }
          }
        }
      } else {
        failed(res?.message || "Error updating form status");
      }
    } catch (error) {
      // console.error("Error processing agreement:", error);
      failed(error.message || "An error occurred while processing the agreement.");
    } finally {
      setIsLoading(false);
    }
  };

    const fetchAndProcessData = async () => {
      try {
        // Step 1: Filter agreements where all participantSets have status "COMPLETED"
        const completedAgreements = agreementsData.filter((agreement) =>
          agreement.data.participantSets.every((set) => set.status === "COMPLETED")
        );

        // Step 2: Match filtered agreements with forms
        const matchedAgreements = completedAgreements.map((agreement) => {
          const matchedForm = application?.applicationForms.find(
            (form) => form.agreementId === agreement.agreementId
          );
          return { agreement, matchedForm };
        });

        // Step 3: Update forms and log matched agreements
        for (const { agreement, matchedForm } of matchedAgreements) {
          if (matchedForm && matchedForm?.status !== "Completed") {
            await filterAndLogCompletedAgreements(agreement, matchedForm);
          }
        }
      } catch (error) {
        // console.error("Error in useEffect:", error);
      }
    };

  useEffect(()=>{
    getSigners();
  },[]);

  const toggleModal = ()=>{
   setShowSignerModel(false);
   setSignerData({});
  };

  const handleFormEditClick = (index, currentTitle) => {
    setFormEditingIndex(index); // Set the index of the form being edited
    setFormTitle(currentTitle);
  };

  const handleFormTitleChange = (e) => {
    setFormTitle(e.target.value);
  };

  const handleFormTitleSaveClick = async(index, formId) => {
    let res;
    try {
      const updatedApplicationForm = application.applicationForms.map((form)=> {
        if(form._id === formId){
          return {
            ...form,
            formTitle : formTitle
          };
        }
        return form;
      });
      const values = {applicationForms : updatedApplicationForm};
      setIsLoading(true);
      res = await updateApplication({values, dispatch, token, applicationId : application?._id});
      if (res?.status === "SUCCESS") {
          setFormEditingIndex(null);
          await getApplication();
          setIsLoading(false);
          success(res?.message);
      }else {
          setIsLoading(false);
          failed(res?.message);
      }
  } catch (error) {
      failed(res?.message);
      setIsLoading(false);
  }
  };

  const handleDownloadAgreement = async (agreementId,sign) => {
    let downloadRes;
    try {
      setIsLoading(true);
      downloadRes = await downloadAgreement({ values: { agreementId,applicationId: application?._id, isDownload:true, key : sign?.formFile.key}, dispatch, token });
          if (downloadRes?.data.key) {
            const updatedApplicationFormWithUrl = application.applicationForms.map(
              (form) =>
                form._id === sign.formId
                  ? { ...form, agreementUrl: downloadRes?.data?.key }
                  : form
          );

          const valuesWithUrl = { applicationForms: updatedApplicationFormWithUrl };
          // Perform the update operation for the agreement URL
          const updateRes = await updateApplication({
            values: valuesWithUrl,
            dispatch,
            token,
            applicationId: application?._id
          });

          await getApplication();
          window.open(downloadRes?.data.signedUrl);
        }
     else {
        failed(downloadRes?.message);
      }
    } catch (error) {
      failed(downloadRes?.message || "Download failed");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };


  const handleDownload = async (sign) => {
    let res;
    try {
      setIsLoading(true);
        const fileUrl = sign?.agreementUrl;
        window.open(fileUrl, "_blank");
    } catch (error) {
      failed(res?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSavePhoneNumber = async (formId, email, newPhoneNumber) => {
    const key = `${formId}-${email}`;
    const currentPhoneNumber =
      phoneNumbers[key] ||
      application?.applicationForms
        ?.find((form) => form._id === formId)
        ?.participants.find((participant) => participant.email === email)?.phone ||
      '';

    // Only save if the phone number has changed
    if (!newPhoneNumber || newPhoneNumber === currentPhoneNumber) {
      setTempPhoneNumbers((prev) => {
        const updated = { ...prev };
        delete updated[key]; // Clear the specific temp phone number
        return updated;
      });
      return;
    }

     try {
    setIsLoading(true);

    const updatedApplicationForm = application.applicationForms.map((form) => {
      if (form._id === formId) {
        const participantIndex = form.participants.findIndex(
          (participant) => participant.email === email
        );

        let updatedParticipants;

        if (participantIndex !== -1) {
          // ✅ Update existing participant
          updatedParticipants = form.participants.map((participant, index) => {
            if (index === participantIndex) {
              return { ...participant, phone: newPhoneNumber };
            }
            return participant;
          });
        } else {
          // ✅ Push new participant
          updatedParticipants = [
            ...form.participants,
            { email, phone: newPhoneNumber }
          ];
        }

        return { ...form, participants: updatedParticipants };
      }
      return form;
    });


      const values = { applicationForms: updatedApplicationForm };
      const res = await updateApplication({
        values,
        dispatch,
        token,
        applicationId: application?._id
      });

      if (res?.status === 'SUCCESS') {
        setFormEditingIndex(null);
        await getApplication();
        success(res?.message);
      } else {
        failed(res?.message);
      }
    } catch (error) {
      failed(error.message || 'An error occurred');
    } finally {
      setIsLoading(false);
      setTempPhoneNumbers((prev) => {
        const updated = { ...prev };
        delete updated[key]; // Clear the specific temp phone number after save
        return updated;
      });
    }
  };

  const handleSendPhoneNumber = async (agreementId, email, phoneNumber) => {
    try {
      setIsLoading(true);
      const res = await sendAgreementViaSMS({ values: {agreementId, email, phoneNumber}, dispatch, token});
      if (res?.status === "SUCCESS") {
        success(res?.message);
        setIsLoading(false);
      } else {
        failed(res?.message);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      failed(error.message);
    }
  };

  const handleTabSwitch = (tab) => {
    setActiveTableTab(tab);
  };

  useEffect(()=>{
      setFormList(application.applicationForms);
  },[activeTableTab,application]);

  const toggleSignModal = () => setSignModal(!signModal);

  const handleSignClick = (url) => {
    setSignUrl(url);
    setSignModal(true);
  };

  const getCompletedFormsForPatient = () => {

    if (!formList || !agreementsData || !PatientEmail) {
      return [];
    }

    const result = formList.filter((sign) => {

      const agreement = agreementsData.find(
        (data) => data?.agreementId === sign?.agreementId
      );
      const isCompleted = agreement?.data?.participantSets?.some(
        (set) => set.status === "COMPLETED"
      );
      const memberEmails = agreement?.data?.participantSets?.flatMap(set =>
        set?.memberInfos?.map(member => member?.email)
      ) || [];
      const isPatientEmailMatched = memberEmails.includes(PatientEmail);
      const shouldInclude = isCompleted && isPatientEmailMatched;
      return shouldInclude;
    });

    return result;
  };

  useEffect(() => {
    const filteredForms = getCompletedFormsForPatient();
    setCompletedPatientForms(filteredForms);
  }, [formList, agreementsData, PatientEmail]);

  return (
    <div className="data_patient">
      {isLoading ? (<Loader/>) : null}
      <div className="application_details_block mt-3 mb-3">
      {role !== platformLayout?.Patient && <Row>
        <h3 className="title_name mt-0">Application Overview</h3>
        <div className="col-xl-4 col-lg-4 application_details">
                            <div className="row">
                              <div className="col-3 text-end"><p>Start Date</p></div>
                              <div className="col-1 text-center"><p>:</p></div>
                              <div className="col-8"><p>{moment(application?.createdAt).format("MMM-DD-YYYY")}</p></div>
                            </div>
                          </div>

                          <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Type</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationType?.applicationTitle}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{stageStatusOption.find(option => option.value === application?.status)?.label || '-'}</p></div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Active Days</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {moment().diff(moment(application?.createdAt), "days") + " Days"}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Consultant</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {application.consultantUser?.[0]
                                  ? `${application.consultantUser?.[0]?.firstName} ${application.consultantUser?.[0]?.lastName}`
                                  : "No Consultant assigned."}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Application Id</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7"><p>{application?.applicationID}</p></div>
                          </div>
                        </div>
      </Row>}
      <Row className="mt-3 align-items-center">
                        <h3 className="title_name mt-1">Primary Applicant</h3>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-3 text-end"><p>Name</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {decryptData(application?.patientData?.name[0].text)}{" "}
                                <button
                                  className="add_notes"
                                  onClick={() =>
                                    navigate("/clinic/patient-profile", {
                                      state: { patientData: application?.patientData?._id, isEditMode: true}
                                    })
                                  }
                                >
                                  View Details
                                </button>
                              </p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-3 text-end"><p>Email ID</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                                {decryptData(
                                  application?.patientData?.telecom.find((obj) => obj?.system === "email")
                                    ?.value || "-"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>Gender</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.gender) || "-"}</p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-4 text-end"><p>Status</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.maritalStatus) || "-"}</p>
                            </div>
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 application_details">
                          <div className="row">
                            <div className="col-4 text-end"><p>DOB</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>{decryptData(application?.patientData?.birthDate) || "-"}</p>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-4 text-end"><p>State</p></div>
                            <div className="col-1 text-center"><p>:</p></div>
                            <div className="col-7">
                              <p>
                              {application.patientData?.address[0].state && decryptData(application.patientData?.address[0].state)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Row>
      </div>
      <h6 className="form_name list_blk mt-2">Signature: </h6>
      <div className="table_space table_listing_color">
        <div className="table-responsive">
            <div className="tabs mt-2">
                <div className="signature_tabs" style={{maxWidth:"auto"}}>
              <Nav tabs className="horizontal-scroll d-flex gap-2">
                {role === "Patient" ? (
                  <>
                    <NavItem>
                      <NavLink
                        className={activeTableTab === "patientActiveSignature" ? "active" : ""}
                        onClick={() => handleTabSwitch("patientActiveSignature")}
                      >
                        Sign Forms
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTableTab === "completedSignature" ? "active" : ""}
                        onClick={() => handleTabSwitch("completedSignature")}
                      >
                        Signed
                      </NavLink>
                    </NavItem>
                  </>
                ) : (
                  <>
                    <NavItem>
                      <NavLink
                        className={activeTableTab === "signatures" ? "active" : ""}
                        onClick={() => handleTabSwitch("signatures")}
                      >
                        Obtain Signatures
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTableTab === "activeSignature" ? "active" : ""}
                        onClick={() => handleTabSwitch("activeSignature")}
                      >
                        Active
                      </NavLink>
                    </NavItem>
                  </>
                )}
              </Nav>
              </div>
            </div>
            {/* Table for forms with agreementId */}
            {activeTableTab === "activeSignature" && (
              <>
            <table>
              <thead>
                <tr className="header_table mt-2">
                  <th>#</th>
                  <th>Form</th>
                  <th>Form Status</th>
                  <th>Member Status</th>
                  <th>Email</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
              {formList?.filter((sign) => sign?.agreementId)?.length > 0 ? (
                formList
                  ?.filter((sign) => sign?.agreementId)
                  .map((sign, index) => {
                    const agreement = agreementsData?.find(
                      (data) => data?.agreementId === sign?.agreementId
                    );
                    const participantsInAgreement = agreement?.data?.participantSets?.flatMap(set => set?.memberInfos) || []; // Use agreement's participant data for emails

                    return (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "first_block" : "second_block"}
                      >
                        <td>{index + 1}</td>
                        <td>
                          {formEditingIndex === index ? (
                            <input
                              type="text"
                              value={formTitle}
                              onChange={handleFormTitleChange}
                              onBlur={() => handleFormTitleSaveClick(index, sign._id)}
                            />
                          ) : (
                            sign?.formTitle
                          )}
                        </td>
                        <td>
                          {agreement?.data.senderInfo?.status}
                        </td>
                        <td>
                          {agreement?.data?.participantSets?.map((set, idx) => (
                            <div key={idx}>
                              {set?.status || "N/A"}
                              <br />
                              <br />
                            </div>
                          ))}
                        </td>
                        <td>
                          {participantsInAgreement.map((participant, idx) => (
                            <div key={idx}>
                              {participant?.email || "N/A"}
                              <br />
                              <br />
                            </div>
                          ))}
                        </td>
                        <td>
                          {participantsInAgreement.map((participant, idx) => (
                            <div key={idx}>
                              {participant?.name || "N/A"}
                              <br />
                              <br />
                            </div>
                          ))}
                        </td>
                          <td>
                          {agreement?.data?.participantSets.map((participant, idx) => {
                            const matchingParticipantInSign = sign?.participants?.find(
                              (signParticipant) => signParticipant.email === participant.memberInfos[0].email
                            );
                            const phoneNumberToShow = phoneNumbers[`${sign._id}-${participant.memberInfos[0].email}`] || matchingParticipantInSign?.phone || '';
                          const shouldShowSendButton =
                            participant.status === "WAITING_FOR_MY_SIGNATURE" || participant.status === "NOT_YET_VISIBLE";
                            return (
                              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {(agreement?.data.senderInfo?.status !== "COMPLETED" && participant.status !== "WAITING_FOR_OTHERS") && (
                                <>
                                <PhoneInput
                                    inputProps={{
                                      name: 'phone',
                                      autoFocus: true
                                    }}
                                    className="number"
                                    country={'us'}
                                    onlyCountries={['us']}
                                    containerClass="react-tel-input"
                                    inputClass="form-control"
                                    value={tempPhoneNumbers[`${sign._id}-${participant.memberInfos[0].email}`] || phoneNumberToShow} // Use specific temp value or the existing one
                                    onChange={(value) => setTempPhoneNumbers((prev) => ({
                                      ...prev,
                                      [`${sign._id}-${participant.memberInfos[0].email}`]: value
                                    }))} // Update tempPhoneNumbers for the specific row
                                    onBlur={() => handleSavePhoneNumber(sign._id, participant.memberInfos[0].email, tempPhoneNumbers[`${sign._id}-${participant.memberInfos[0].email}`])}
                                    />
                                </>)}
                                {phoneNumberToShow  && shouldShowSendButton &&(
                                    <button
                                      onClick={() =>
                                        handleSendPhoneNumber(sign.agreementId, participant.memberInfos[0].email, phoneNumberToShow)
                                      }
                                      className="add_notes"
                                    >
                                      Send
                                    </button>
                                  )}
                                <br />
                                <br />
                              </div>
                            );
                          })}
                        </td>

                        <td className="p-0 upload_blk">
                          <Dropdown
                            isOpen={dropdownOpen.includes(sign?._id)}
                            toggle={() => toggleDropdown(sign._id)}
                          >
                            <DropdownToggle caret size="xl" className="column_blk">
                              <div className="for_details">
                                <i className="fa fa-ellipsis-v"></i>
                              </div>
                            </DropdownToggle>
                            <DropdownMenu>
                            {sign.status !=="Completed" &&
                              <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleFormEditClick(index, sign?.formTitle)}>
                                <div
                                  className="add_hosp"
                                >
                                  Edit
                                </div>
                              </DropdownItem>}
                              {agreement?.data?.senderInfo?.status !== "COMPLETED" && (
                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleRemoveSigner(sign?.agreementId, sign?.formId)}>
                                  <div
                                    className="add_hosp"
                                  >
                                    Reset Signer
                                  </div>
                                </DropdownItem>
                              )}
                              <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => sign?.agreementUrl ? handleDownload(sign) : handleDownloadAgreement(sign?.agreementId,sign)}>
                                <div
                                  className="add_hosp"
                                >
                                  Download Form
                                </div>
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })) : (
                    <tr>
                      <td colSpan="8" className="text-center">No data found</td>
                    </tr>
                  )}
              </tbody>
            </table>
            </>
            )}
            {/* Table for forms without agreementId */}
            {activeTableTab === "signatures" && (
              <div className="mt-2">
             <table>
              <thead>
                <tr className="header_table mt-2">
                  <th></th>
                  <th>Form</th>
                  <th>Add Signer</th>
                </tr>
              </thead>
              <tbody>
                {application?.applicationForms?.filter(
                  (sign) => !sign?.agreementId && sign.status === formStatus.READY_TO_SIGN
                ).length > 0 ? (
                  application.applicationForms
                    .filter((sign) => !sign?.agreementId && sign.status === formStatus.READY_TO_SIGN)
                    .map((sign, index) => (
                      <tr key={index} className={index % 2 === 0 ? "first_block" : "second_block"}>
                        <td>{index + 1}</td>
                        <td>{sign?.formTitle}</td>
                        <td className="p-0">
                          <button
                            className="add_document"
                            onClick={() => {
                              setShowSignerModel(true);
                              setSignerData(sign);
                            }}
                          >
                            Add Signer
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-3">No data found</td>
                  </tr>
                )}
              </tbody>
            </table>
              </div>
            )}
            {/* Table for Patient to show Active to be Sign form*/}
            {activeTableTab === "patientActiveSignature" && (
              <div className="mt-2">
                <table>
                  <thead>
                    <tr className="header_table mt-2">
                      <th></th>
                      <th>Form Title</th>
                      <th>Sign Form</th>
                    </tr>
                  </thead>
                  <tbody>
                    {application?.applicationForms
                      ?.filter((form) =>
                        form?.participants?.some(
                          (p) => (p?.email) === PatientEmail
                        ) &&
                        form?.status !== "Completed"
                      )
                      ?.map((form, index) => (
                        <tr key={form.formId || index}>
                          <td>{index + 1}</td>
                          <td>{form?.formTitle}</td>
                           <td>
                            {form?.participants?.map(
                              (p) =>
                                p?.email === PatientEmail && (
                                  <button
                                    key={p?.esignUrl}
                                    className="btn btn-primary"
                                    onClick={() => handleSignClick(p?.esignUrl)}
                                  >
                                    Sign
                                  </button>
                                )
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {/* Sign Form Modal */}
                <Modal isOpen={signModal} toggle={toggleSignModal} size="lg">
                  <ModalHeader toggle={toggleSignModal}>Sign Form</ModalHeader>
                  <ModalBody style={{ height: "80vh" }}>
                    {signUrl ? (
                      <iframe
                        src={signUrl}
                        title="Sign Form"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                      />
                    ) : (
                      <p>Loading...</p>
                    )}
                  </ModalBody>
                </Modal>
              </div>
            )}
              {/* Table for Patient to show Completed Sign form*/}
            {activeTableTab === "completedSignature" && (
              <div className="mt-2">
                <table>
                  <thead>
                    <tr className="header_table mt-2">
                      <th></th>
                      <th>Form Title</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                 <tbody>
                  {completedPatientForms.length > 0 ? (
                    completedPatientForms.map((sign, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{sign?.formTitle}</td>
                        <td className="p-0 upload_blk">
                          <Dropdown
                            isOpen={dropdownOpen.includes(sign?._id)}
                            toggle={() => toggleDropdown(sign._id)}
                          >
                            <DropdownToggle caret size="xl" className="column_blk">
                              <div className="for_details">
                                <i className="fa fa-ellipsis-v"></i>
                              </div>
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => sign?.agreementUrl ? handleDownload(sign) : handleDownloadAgreement(sign?.agreementId)}>
                                <div
                                  className="add_hosp"
                                >
                                  Download Form
                                </div>
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No completed forms found for this patient.</td>
                    </tr>
                  )}
                </tbody>
                </table>
              </div>
            )}
          </div>
        {
          signerModelShow && (
            <AdobeSignatureModel signerData={signerData} signerModelShow={signerModelShow} toggleModal={toggleModal} application={application} getApplication={getApplication} getAgreementList={getAgreementList} setActiveTableTab={setActiveTableTab}/>
          )
        }
      </div>
    </div>
  );
};

export default Signature;
